"use strict";
/*
 * Created on 8. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var RoundedProductPrice_1 = require("../model/RoundedProductPrice");

var RoundedProductPriceConverter_1 = require("./RoundedProductPriceConverter");
/**
 * @author Radek Beran
 */


var RoundedProductPriceConverterImpl =
/*#__PURE__*/
function (_RoundedProductPriceC) {
  _inherits(RoundedProductPriceConverterImpl, _RoundedProductPriceC);

  function RoundedProductPriceConverterImpl() {
    _classCallCheck(this, RoundedProductPriceConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoundedProductPriceConverterImpl).apply(this, arguments));
  }

  _createClass(RoundedProductPriceConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new RoundedProductPrice_1.RoundedProductPrice(!utils_1.Utils.isValueMissing(source.value) ? conversions.toBigNumber(source.value) : null, !utils_1.Utils.isValueMissing(source.valueRounded) ? conversions.toBigNumber(source.valueRounded) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        value: source.value !== null ? conversions.fromBigNumber(source.value) : null,
        valueRounded: source.valueRounded !== null ? conversions.fromBigNumber(source.valueRounded) : null
      });
      return result;
    }
  }]);

  return RoundedProductPriceConverterImpl;
}(RoundedProductPriceConverter_1.RoundedProductPriceConverter);

exports.RoundedProductPriceConverterImpl = RoundedProductPriceConverterImpl;